// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__DBhpK","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__DmuTq"};